export const ethStakeAccountState = ({ currency }) => {
  return {
    isDelegating: false,
    isUndelegateInProgress: false,
    canClaimUndelegatedBalance: false,
    minDelegateAmount: currency.defaultUnit(0.1),
    delegatedBalance: currency.ZERO,
    rewardsBalance: currency.ZERO,
    unclaimedUndelegatedBalance: currency.ZERO,
    pendingBalance: currency.ZERO,
    pendingDepositedBalance: currency.ZERO,
    totalRewardsReceived: currency.ZERO,
    lastStakingTxProcessed: '',
  }
}
